export const labels =
{titulo1: ["Tiranía Dogmatíca y Tiranía Populista", "Dogmatic Tyranny and Populist Tyranny"],
titulo2: ["Inicio","Home"],
titulo3: ["El libro", "The book"],
titulo4: ["Comprar", "Buy"]}